export interface OperatorMessage {
  uuid?: string;
  message_type: MessageType;
  [key: string]: any;
  action?: ChatAction;
  timestamp?: string;
}

export enum ChatAction {
  RESET_CHAT = 'reset_chat',
  SHOW_MENU = 'show_menu',
}

export interface MenuOption {
  text: string;
  description: string;
}

export enum MessageType {
  UI_INFO = 'internal FE info',
  INFORMATIONAL = 'informational',
  INPUT = 'input',
  COMMAND = 'command',
  EDIT = 'edit',
  MENU = 'menu',
  BUTTON_PRESS = 'button_press',
  REPLY = 'reply',
  HELLO = 'hello',
}

export enum ClientCapability {
  CHOICE = 'choice',
  CHOICE_PAGINATION = 'choice_pagination',
  FORM = 'form',
  KEYBOARD = 'keyboard',
  MODAL = 'modal',
  TEXT_INPUT = 'text_input',
}
